var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fix-padding", attrs: { fluid: "" } },
    [
      _c(
        "v-col",
        { attrs: { lg: "12" } },
        [
          _c("v-breadcrumbs", {
            staticClass: "p-0",
            attrs: { items: _vm.breadcrumbs },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex" },
        [
          _c(
            "v-col",
            { staticClass: "pt-0 bg-white", attrs: { lg: "12", cols: "12" } },
            [
              _c(
                "div",
                { staticClass: "d-flex" },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "8" } },
                    [
                      _c(
                        "v-card-text",
                        { staticClass: "search-form" },
                        [
                          _c("v-combobox", {
                            attrs: {
                              "search-input": _vm.search,
                              placeholder: "Enter the goal name",
                              "prepend-icon": "mdi-database-search",
                            },
                            on: {
                              "update:searchInput": function ($event) {
                                _vm.search = $event
                              },
                              "update:search-input": function ($event) {
                                _vm.search = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "2" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "me-2 mt-4 search-test",
                          on: {
                            click: function ($event) {
                              _vm.search = ""
                            },
                          },
                        },
                        [_vm._v("クリア")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.userGoals, function (userGoal) {
                return [
                  _c(
                    "v-list-item",
                    {
                      key: userGoal.id,
                      staticClass: "d-flex align-stretch",
                      attrs: {
                        to: "/classroom/user-goals/" + userGoal.id,
                        cytag: "course-item",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-center py-6 pe-3" },
                        [
                          _c("v-img", {
                            attrs: {
                              width: "70",
                              height: "70",
                              src: userGoal.goal.image.url,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex flex-column justify-space-between py-5",
                          staticStyle: { width: "calc(100% - 70px)" },
                        },
                        [
                          _c(
                            "div",
                            [
                              _c("div", [
                                _c("span", [
                                  _vm._v(
                                    " " + _vm._s(userGoal.goal.name) + " "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("v-list-item-subtitle", {
                                domProps: {
                                  innerHTML: _vm._s(userGoal.goal.description),
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "mt-2",
                              style: { width: _vm.mobile ? "100%" : "40%" },
                            },
                            [
                              _c(
                                "v-progress-linear",
                                {
                                  attrs: {
                                    value: userGoal.progressRate,
                                    height: "15",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(userGoal.progressRate) +
                                      "%\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }